<template>
  <div>
    <div class="lightbox" v-if="lightbox" @click="lightboxOuterClick($event)">
      <div class="lightbox__inner" @click="innerClick($event)" v-if="lightbox !== 'loading'">
        <app-password-change v-if="lightbox === 'passwordChange'"></app-password-change>
        <app-password-reset v-if="lightbox === 'passwordReset'"></app-password-reset>
        <app-book-detail-result v-if="lightbox === 'bookDetailResult'"></app-book-detail-result>
        <app-about-security v-if="lightbox === 'aboutSecurity'"></app-about-security>
        <cancel-subscription-result v-if="lightbox === 'cancelSubscriptionResult'"></cancel-subscription-result>
        <subscription-result v-if="lightbox === 'subscriptionResult'"></subscription-result>
        <unlimited-result v-if="lightbox === 'unlimitedResult'"></unlimited-result>
        <cancel-unlimited-result v-if="lightbox === 'cancelUnlimitedResult'"></cancel-unlimited-result>
        <yadokari-result v-if="lightbox === 'yadokariResult'"></yadokari-result>
      </div>
      <app-loading v-else></app-loading>
    </div>
  </div>
</template>

<script>
  import PasswordChange from './PasswordChange.vue';
  import PasswordReset from './PasswordReset.vue';
  import BookDetailResult from './BookDetailResult.vue';
  import AboutSecurity from './AboutSecurity.vue';
  import Loading from './Loading.vue';
  import CancelSubscriptionResult from './CancelSubscriptionResult.vue';
  import CancelUnlimitedResult from './CancelUnlimitedResult.vue';
  import SubscriptionResult from './SubscriptionResult.vue';
  import UnlimitedResult from './UnlimitedResult.vue';
  import YadokariResult from './YadokariResult.vue';

  export default {
    methods: {
      lightboxOuterClick(e) {
        if (this.lightbox !== 'loading') {
          this.$store.dispatch("hideLightBox");
        }
      },
      innerClick(e) {
        e.stopPropagation();
      }
    },
    computed: {
      lightbox() {
        return this.$store.getters.lightbox;
      }
    },
    components: {
      appPasswordChange: PasswordChange,
      appPasswordReset: PasswordReset,
      appBookDetailResult: BookDetailResult,
      appLoading: Loading,
      appAboutSecurity: AboutSecurity,
      cancelSubscriptionResult: CancelSubscriptionResult,
      subscriptionResult: SubscriptionResult,
      unlimitedResult:UnlimitedResult,
      cancelUnlimitedResult:CancelUnlimitedResult,
      yadokariResult:YadokariResult,
    }
  }
</script>

<style scoped lang="scss">
  .lightbox {
    &__inner {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lightbox/Home.vue